/**
 * 组件操作
 */
export enum PartOperation {
  /** 城市选择 */
  selectedCity
}
